<template>
	<van-popup v-model="show" class="department_dialog" :close-on-click-overlay="false">
		<div class="department_dialog-title">{{item.hospitalName}}</div>
		<div class="department_dialog-title">{{item.teamName}}</div>
		<div class="base-toast">将由此医疗团队来为您提供康复管理服务</div>
		<div class="divider-row-one">
			<van-divider class="divider-item"> 团队介绍 </van-divider>
		</div>
		<div class="department_dialog-card">
			<base-ellipsis :text="item.teamProfile" />
		</div>

		<div class="divider-row">
			<van-divider class="divider-item"> 我的医生团队 </van-divider>
		</div>
		<div class="doctor_list">
			<div
				class="doctor_list_item display-flex department_dialog-card mb-12"
				v-for="person in item.doctorTeamList"
				:key="person.id"
			>
				<van-image class="avatar_image" fit="cover" round :src="person.avatar" />
				<div class="doctor_list_item-name">{{person.doctorName}}</div>
				<div class="doctor_list_item-title_name">{{person.title}}</div>
			</div>
		</div>

		<van-button class="mt-28" block round type="primary" @click="read">知道了</van-button>
	</van-popup>
</template>
<script>

export default {
    data () {
        return {}
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        item: {
            tyoe: Object,
            default: {}
        },
        goMain: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        show: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        async read () {
            this.show = false

            if (this.goMain) {
                this.$router.replace('/')
            }
            // let { code } = await this.$api.patient.setDepartmentStatus(this.$store.getters['account/getPatientId'])
            // if (!code) {
            //     this.show = false
            // }
        }
    }
}
</script>
<style scoped lang="less">
.department_dialog {
	background-image: url('../../../assets/img/department_dialog_bg.png');
	background-size: 100% auto;
	background-repeat: no-repeat;
	border-radius: 20px;
	width: 582px;
	padding: 40px;
	&-title {
		font-size: 36px;
		color: #1f2329;
		text-align: center;
		line-height: 48px;
		font-weight: 500;
	}
	&-card {
		background-color: #ffffff;
		border-radius: 24px;
		padding: 20px;
		border: 1px solid #d8d8d8;
	}
}
.doctor_list {
	max-height: 30vh;
	overflow: hidden;
	overflow-y: scroll;
}
.doctor_list_item {
	align-items: center;
	&-name {
		font-size: 30px;
		color: #1f2329;
		margin: 0 20px;
		font-weight: 500;
	}
	&-title_name {
		font-size: 24px;
		color: #8f959e;
	}
}
.avatar_image {
	height: 80px;
	width: 80px;
}
.base-toast {
	color: #8f959e;
	font-size: 28px;
	text-align: center;
	margin-top: 8px;
	line-height: 40px;
}
.divider-row {
	margin: 0 auto;
	width: 260px;
}
.divider-row-one {
	margin: 0 auto;
	width: 200px;
}
</style>
